"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureFlagEnabled = void 0;
/**
 * Checks if a specific feature flag is enabled.
 *
 * @param {FeatureFlags | null} featureFlags
 * @param {string} flagName - The name of the feature flag to check.
 * @returns {boolean} - Returns `true` if the feature flag is enabled.
 */
const isFeatureFlagEnabled = (featureFlags, flagName) => {
    return !!(featureFlags && featureFlags[flagName]);
};
exports.isFeatureFlagEnabled = isFeatureFlagEnabled;
